// Victory kit icons per product — mirrors service_icon_name in
// packs/application/app/public/application_helper.rb
const PRODUCT_ICONS: Record<string, string> = {
  window: "victory-windows",
  roofing: "victory-roofing",
  siding: "victory-siding",
  gutter: "victory-gutter",
  attic: "victory-attic",
};

export default PRODUCT_ICONS;
